import { useState } from "react";
import {
  DEFAULT_SESSION_BOOKING_VAR,
  DEFAULT_LOCAL_STORAGE_KEY_FOR_SESSION_BOOKING_STATE,
} from "../constants";
import useLocalStorage from "./useLocalStorage";

const useSessionTherapyContext = (): SessionBookingState => {
  const { getValue, setValue } = useLocalStorage<SessionBookingVars>();
  const [sessionBookingState, setBookingState] = useState<SessionBookingVars>(
    getValue(DEFAULT_LOCAL_STORAGE_KEY_FOR_SESSION_BOOKING_STATE) ?? DEFAULT_SESSION_BOOKING_VAR
  );

  const updateSessionBookingState = (sessionBookingState: SessionBookingVars) => {
    setBookingState(sessionBookingState);
    setValue(DEFAULT_LOCAL_STORAGE_KEY_FOR_SESSION_BOOKING_STATE, sessionBookingState);
  };

  return { sessionBookingState, updateSessionBookingState };
};

export default useSessionTherapyContext;
